import { useState } from "react";
import logo from "../images/logo.png";
import { getActiveUser, setActiveUser } from "../services/authLock";
import { authAPI } from "../services/api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [takeoverPrompt, setTakeoverPrompt] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setTakeoverPrompt(false);

    try {
      const res = await authAPI.login(username, password);
      console.log("Login result:", res.data);

      if (res.data.success) {
        sessionStorage.setItem("auth", "true");
        setActiveUser(username);
        onLogin();
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 401) {
          setError("Invalid username or password");
        } else if (err.response.status === 409) {
          setTakeoverPrompt(true);
        } else {
          setError("Login failed. Try again.");
        }
      } else {
        setError("Network error. Please try later.");
      }
    }
  };

  const confirmTakeover = async () => {
    try {
      const res = await authAPI.login(username, password, true);
      if (res.data.success) {
        sessionStorage.setItem("auth", "true");
        setActiveUser(username);
        onLogin();
      }
    } catch (err) {
      setError("Takeover failed. Try again.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-950 p-4">
      <form
        onSubmit={handleSubmit}
        className="bg-slate-900 border border-slate-700 p-8 rounded-xl shadow-2xl shadow-black/40 w-full max-w-sm"
      >
        <img src={logo} className="mb-6 opacity-90 mx-auto" alt="Logo" />
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          className="border border-slate-600 bg-slate-800 text-slate-100 placeholder-slate-500 p-3 w-full rounded-lg mb-3 focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="border border-slate-600 bg-slate-800 text-slate-100 placeholder-slate-500 p-3 w-full rounded-lg mb-3 focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
        />
        {error && <p className="text-red-400 text-sm mb-2">{error}</p>}

        {takeoverPrompt && (
          <div className="text-sm text-amber-400 mb-3 p-3 rounded-lg bg-amber-950/40 border border-amber-900/50">
            Another user is already logged in.
            <br />
            <button
              type="button"
              className="bg-amber-600 text-slate-950 font-medium px-3 py-2 rounded-lg mt-2 hover:bg-amber-500"
              onClick={confirmTakeover}
            >
              Take Over
            </button>
          </div>
        )}

        <button
          type="submit"
          className="bg-primary-600 text-white px-4 py-3 rounded-lg w-full font-medium hover:bg-primary-500 transition-colors"
        >
          Login
        </button>
      </form>
    </div>
  );
}
